import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

const fundRouters: RouteRecordRaw[] = [
    {
        path: "/fund",
        name: "Fund",
        meta: { title: "资金管理" },
        component: () => import("@/views/layouts/index.vue"),
        children: [
            {
                path: "payment",
                name: "Payment",
                meta: { title: "付款管理", keepAlive: true, pageType: PAGE_TYPE.LIST.code },
                component: () => import("@/views/pages/fundManagement/paymentManagement/index.vue")
            },

            {
                path: "payment/paymentDetail",
                name: "PaymentDetail",
                meta: { title: "付款详情", hidden: true, activeMenu: "Payment" },
                component: () => import("@/views/pages/fundManagement/paymentManagement/detail.vue")
            },
            {
                path: "payment/paymentAdd",
                name: "PaymentAdd",
                meta: {
                    title: "新增付款",
                    hidden: true,
                    activeMenu: "Payment",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                },
                component: () => import("@/views/pages/fundManagement/paymentManagement/form.vue")
            },
            {
                path: "payment/financingPayForm",
                name: "FinancingPayForm",
                meta: {
                    title: "新增付款",
                    hidden: true,
                    activeMenu: "Payment",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                },
                component: () => import("@/views/pages/fundManagement/paymentManagement/financingPayForm.vue")
            },
            {
                path: "payment/paymentEdit",
                name: "PaymentEdit",
                meta: {
                    title: "修改付款",
                    hidden: true,
                    activeMenu: "Payment",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                },
                component: () => import("@/views/pages/fundManagement/paymentManagement/form.vue")
            },
            {
                path: "collection",
                name: "Collection",
                meta: { title: "收款管理", keepAlive: true, pageType: PAGE_TYPE.LIST.code },
                component: () => import("@/views/pages/fundManagement/collectionManagement/index.vue")
            },
            {
                path: "collection/collectionDetail",
                name: "CollectionDetail",
                meta: { title: "收款详情", hidden: true, activeMenu: "Collection" },
                component: () => import("@/views/pages/fundManagement/collectionManagement/detail.vue")
            },
            {
                path: "refund",
                name: "Refund",
                meta: { title: "退款管理", keepAlive: true, pageType: PAGE_TYPE.LIST.code },
                component: () => import("@/views/pages/fundManagement/refundManagement/index.vue")
            },
            {
                path: "refund/refundDetail",
                name: "RefundDetail",
                meta: { title: "退款详情", hidden: true, activeMenu: "Refund" },
                component: () => import("@/views/pages/fundManagement/refundManagement/detail.vue")
            },
            {
                path: "refund/refundAdd",
                name: "RefundAdd",
                meta: {
                    title: "新增退款",
                    hidden: true,
                    activeMenu: "Refund",
                    keepAlive: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code
                },
                component: () => import("@/views/pages/fundManagement/refundManagement/form.vue")
            },
            {
                path: "refund/refundEdit",
                name: "RefundEdit",
                meta: {
                    title: "修改退款",
                    hidden: true,
                    activeMenu: "Refund",
                    keepAlive: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code
                },
                component: () => import("@/views/pages/fundManagement/refundManagement/form.vue")
            }
            // {
            //     path: "quotaChange",
            //     name: "QuotaChange",
            //     component: () => import("@/views/pages/fundManagement/quotaChange/index.vue"),
            //     meta: {
            //         title: "额度变更",
            //         keepAlive: true,
            //         pageType: PAGE_TYPE.LIST.code
            //     }
            // },
            // {
            //     path: "quotaChangeAdd",
            //     name: "QuotaChangeAdd",
            //     component: () => import("@/views/pages/fundManagement/quotaChange/form.vue"),
            //     meta: {
            //         title: "新增额度变更",
            //         activeMenu: "QuotaChange",
            //         hidden: true,
            //         pageType: PAGE_TYPE.CACHE_FORM.code,
            //         keepAlive: true
            //     }
            // },
            // {
            //     path: "quotaChangeEdit",
            //     name: "QuotaChangeEdit",
            //     component: () => import("@/views/pages/fundManagement/quotaChange/form.vue"),
            //     meta: {
            //         title: "修改额度变更",
            //         activeMenu: "QuotaChange",
            //         hidden: true,
            //         pageType: PAGE_TYPE.CACHE_FORM.code,
            //         keepAlive: true
            //     }
            // },
            // {
            //     path: "quotaChangeDetail",
            //     name: "QuotaChangeDetail",
            //     component: () => import("@/views/pages/fundManagement/quotaChange/detail.vue"),
            //     meta: {
            //         title: "额度详情",
            //         activeMenu: "QuotaChange",
            //         hidden: true
            //     }
            // }
        ]
    }
];

export default fundRouters;
